module.exports = __webpack_public_path__ + "img/dis-diag.45cf6486.png";